import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../components/Button';
import Dialog from '../../../components/Dialog';

const ProjectWizardTakeoverRequestDialog = ({
  visible,
  requesterDisplayName,
  isResponding,
  onDeny,
  onAccept,
}) => (
  <Dialog
    title="Edit access requested"
    visible={visible}
    onCancel={onDeny}
    footer={
      <div className="cluster-2">
        <Button
          data-testid="button-takeover-deny"
          onClick={onDeny}
          disabled={isResponding}
        >
          Deny
        </Button>
        <Button
          data-testid="button-takeover-accept"
          type="primary"
          loading={isResponding}
          onClick={onAccept}
        >
          Allow and hand off
        </Button>
      </div>
    }
  >
    <p className="m-0 text-sm text-neutral-300 dark:text-neutral-300">
      {requesterDisplayName || 'Another user'} is requesting edit access to this
      project. If you allow, your edit session will end and they can take over.
    </p>
  </Dialog>
);

ProjectWizardTakeoverRequestDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  requesterDisplayName: PropTypes.string,
  isResponding: PropTypes.bool,
  onDeny: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
};

ProjectWizardTakeoverRequestDialog.defaultProps = {
  requesterDisplayName: '',
  isResponding: false,
};

export default ProjectWizardTakeoverRequestDialog;
